import { Typography } from '@material-ui/core';
import ReactHookTextField from 'components/ReactHookTextField';

export const ShaftSealElementA = ({control, tableView}) => {
    return <ShaftSealElement control={control} tableView={tableView} type='A'/>
}

export const ShaftSealElementB = ({control, tableView}) => {
    return <ShaftSealElement control={control} tableView={tableView} type='B'/>
}

const ShaftSealElement = ({ control, tableView, type }) => {
    return (
        <>
            {!tableView ? <Typography variant="h6" gutterBottom>Shaft Seal Element {type}</Typography> : <br/>}
            <ReactHookTextField
                name={`attributes.shaftSealElement${type}Qty`}
                type='text'
                control={control}
                label='Qty'
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name={`attributes.shaftSealElement${type}Notes`}
                type='text'
                control={control}
                label='Notes'
                style={{width: '19%', marginRight: '1%'}}
            />
        </>
    );
};

export default ShaftSealElement;
